import { AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChildren, HostListener, SimpleChanges, OnChanges } from '@angular/core';
import { BaseComponent } from '../../../../shared/commons/base-component/base.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { HelpersService } from '../../../../core/helpers/helpers.service';
import { EpgItem, Program } from '../../../../data/btv/model/epg-item';
import { ChannelP } from '../../../../data/360-client-api';
import { DatePipe, Location } from '@angular/common';
import { BtvDataRestService } from '../../../../data/btv/btv-data-rest.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MetaService } from '../../../../data/meta/meta.service';
import { SeoService } from '../../../../data/seo/seo-service.service';

// import * as $ from 'jquery';
declare var $: any;
declare var videojs;
declare var Glider: any;

@Component({
  selector: 'app-channel-carousel',
  templateUrl: './channel-carousel.component.html',
  styleUrls: ['./channel-carousel.component.css']
})
export class ChannelCarouselComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  listID: string;
  public channels: Array<ChannelP>;
  player: any;
  index: number = 0;
  selectedChannel: ChannelP = null;
  programs: Program[] = [];
  playingProgram: Program = null;
  nextProgram: Program = null;
  nowDate: number;
  timeSlot: any[] = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"]
  routerSubs: Subscription
  isMobile: boolean;
  isTablet: boolean;
  isPlay: boolean = false;
  isDesktop: boolean;
  @ViewChildren('carouselItems2') carouselItems: QueryList<any>;
  @ViewChildren('programItems') programItems: QueryList<any>;
  private changeSubscription: Subscription;
  private programSubs: any;
  isChannelChange: boolean = false;
  startTime: number = 1578268800000;
  endTime: number = 1578441600000;
  cuTvTimes: number[] = [];

  constructor(helpers: HelpersService,
    private dataSource: BtvDataRestService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private deviceService: DeviceDetectorService,
    private metaService: MetaService,
    private seoService: SeoService,
    private _location: Location
  ) {
    super(helpers);

    this.isMobile = deviceService.isMobile();
    this.isTablet = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();
    this.nowDate = Date.now(); // datalar uygun olunca bu kod kullanılacak
    // console.log("now date: ", this.datePipe.transform(Date.now, 'dd/MM/yyyy HH:mm', 'GMT'))

    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.listID = this.route.snapshot.paramMap.get('id');
        this.isChannelChange = false;
        this.getChannels();
      }
    });
  }

  ngOnInit() {
    this.listID = this.route.snapshot.paramMap.get('id');
    this.calculateTimeRange();
  }

  calculateTimeRange() {
    for(var i = this.startTime; i <= this.endTime; i += 1800000) {
      this.cuTvTimes.push(i);
    }
    setTimeout(() => {
      this.epgDayCarouselInit();
    }, 50);
  }

  epgDaySubscription: Subscription;
  epgDayGlider: any;
  epgDayCarouselInit() {
    this.epgDaySubscription = this.carouselItems.changes.subscribe(t => {
      this.epgDayGlider = new Glider(document.querySelector('#example-glider'), {
        slidesToShow: 12.5,
        slidesToScroll: 1,
        draggable: true,
        rewind: true,
        duration: 1.2,
        dragVelocity: 1,
        responsive: [
          {
            // screens greater than >= 1024px
            breakpoint: 1350,
            settings: {
              slidesToShow: 9.2,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 479px
            breakpoint: 479,
            settings: {
              slidesToShow: 4.6,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 479px
            breakpoint: 0,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
            }
          },
        ],
      });

    });

  }

  destroyPlayer() {
    if (this.selectedChannel != undefined && this.selectedChannel != null) {
      this.player.dispose();
      this.player = null;
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.getChannels();
    // REF: https://stackoverflow.com/questions/37087864/execute-a-function-when-ngfor-finished-in-angular-2
    // this.changeSubscription = this.carouselItems.changes.subscribe(t => {
    //   $('#video-carousel').owlCarousel({
    //     items: 12,
    //     itemsDesktop: [1199, 10],
    //     itemsDesktopSmall: [991, 10],
    //     itemsTablet: [767, 10],
    //     itemsMobile: [479, 4.5],
    //     slideSpeed: 200,
    //     navigation: false,
    //     // navigationText: ['<i class=\"fa fa-angle-left\"></i>', '<i class=\"fa fa-angle-right\"></i>'],
    //     pagination: false,
    //   });
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.listID && !changes.listID.isFirstChange()) {
    }
  }

  getChannels() {
    this.dataSource.getChannels().subscribe(data => {
      this.channels = data;
      this.selectChannel();
    });
  }

  selectChannel() {
    if (this.listID == 'sportstv') {
      this.selectedChannel = this.channels.filter(channel => channel.no === 1)[0];
    }
    else if (this.listID == 'sportstvkadin') {
      this.selectedChannel = this.channels.filter(channel => channel.no === 2)[0]
    }

    if (this.selectedChannel != undefined && this.selectedChannel != null) {
      //this.metaService.updateTitle('canlı');
      //this.metaService.updateMetaInfo(this.selectedChannel.description);
      // this.getEpgDataByChannel();
      this.playPlayer();
    }
    this.isChannelChange = true
  }



  ngOnDestroy(): void {
    if (this.isPlay) {
      this.stopChannel();
    }
    this.destroyPlayer();

    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
      this.changeSubscription = null;
    }
    if (this.programSubs) {
      this.programSubs.trigger('destroy.owl.carousel');
      this.programSubs = null;
    }

    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
    }
  }


  playPlayer() {
    setTimeout(() => {
      if (!this.player) {
        this.player = videojs('tv-player', {
          autoplay: true,
          controls: true,
          fluid: true,
          controlBar: {
            playToggle: {
              replay: true
            },
            volumePanel: {
              inline: false
            }
          },
          liveui: true
        }
        );
        this.player.src([
          { type: 'application/x-mpegURL', src: this.selectedChannel.url }
        ]);
      }
      else {
        this.player.src([
          { type: 'application/x-mpegURL', src: this.selectedChannel.url }
        ]);
      }
      // this.player.removeClass('vjs-live')
      this.player.poster('assets/images/sportstv/trnsplogo.png')

      this.player.on('pause', () => {
        this.isPlay = false;
        this.stopChannel()
      })
      this.player.on('play', () => {
        this.isPlay = true;

        this.startChannel()
      })
      // this.player.src([
      //   { type: 'application/x-mpegURL', src: this.selectedChannel.url }
      // ]);
      // this.player.on('dblclick', function() {
      //   if (this.player.isFullscreen()) {
      //     this.player.exitFullscreen();
      //   } else {
      //     this.player.requestFullscreen();
      //   }
      // });
    }, 100)
  }


  startChannel() {
    this.dataSource.startChannel(this.selectedChannel.id).subscribe(data => {
    })
  }

  stopChannel() {
    this.dataSource.stopChannel(this.selectedChannel.id).subscribe(data => {
    })
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    // if (this.isPlay) {
    this.destroyPlayer()
    this.stopChannel();
    // }
  }




  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    // if (this.isPlay) {
    this.destroyPlayer()
    this.stopChannel();
    // }
  }

  locationBack() {
    if (!!sessionStorage.getItem("urlhistory") && JSON.parse(sessionStorage.getItem("urlhistory")).length < 2) {
      this.router.navigateByUrl('');
    }
    else {
      this._location.back();
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/btv/widgets/channel-carousel/channel-carousel.component.ts